import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Modal from './modal';

export default function AddField({ playbook, stage }) {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <AddControl id="add-data-field" onClick={() => setShowModal(true)}>
      Data Field
    </AddControl>

    {!showModal ? null :
      <Modal
        playbook={playbook}
        stage={stage}
        onHide={() => setShowModal(false)}
      />
    }
  </React.Fragment>;
}

AddField.propTypes = {
  playbook: PropTypes.object,
  stage: PropTypes.string,
};
